import axios from 'axios';

const API_BASE = 'https://eft-app-production.up.railway.app/api';

const api = axios.create({ baseURL: API_BASE });

// Attach JWT token to every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('mts_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle auth errors globally
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // Token expired - clear and reload
      localStorage.removeItem('mts_token');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

// Auth
export const socialLogin = (data) => api.post('/auth/social', data);
export const register = (data) => api.post('/auth/register', data);
export const login = (data) => api.post('/auth/login', data);
export const getMe = () => api.get('/auth/me');
export const forgotPassword = (email) => api.post('/auth/forgot-password', { email });
export const resetPassword = (token, new_password) => api.post('/auth/reset-password', { token, new_password });

// Scripts
export const generateScriptGuest = (data) => api.post('/scripts/generate-guest', data);
export const generateScript = (data) => api.post('/scripts/generate', data);
export const getScripts = () => api.get('/scripts');
export const getScript = (id) => api.get(`/scripts/${id}`);
export const deleteScript = (id) => api.delete(`/scripts/${id}`);

// Categories & metadata
export const getCategories = () => api.get('/categories');
export const getStyles = () => api.get('/styles');
export const getEmotions = () => api.get('/emotions');

// Subscription
export const getSubscriptionStatus = () => api.get('/subscription/status');
export const upgradeSubscription = () => api.post('/subscription/upgrade');

// PDF email delivery
export const sendScriptPDF = (data) => api.post('/scripts/send-pdf', data);

// Feedback
export const submitFeedback = (data) => api.post('/feedback/feature-request', data);

export default api;
